const API_BASE = "/wp-json/wp/v2";

/**
 * Wspólna funkcja do pobierania danych z WordPress REST API.
 * @param {string} endpoint - Endpoint API, np. `menus/main-menu`.
 * @param {object} [params] - Parametry zapytania jako obiekt.
 * @returns {Promise<any>} - Dane pobrane z API.
 */
const fetchFromWordpressApi = async (endpoint, params = {}) => {
    try {
        const queryParams = new URLSearchParams(params).toString();
        const url = queryParams ? `${API_BASE}/${endpoint}?${queryParams}` : `${API_BASE}/${endpoint}`;
        const response = await fetch(url);

        if (!response.ok) {
            throw new Error(`Failed to fetch from ${endpoint}: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error(`Error fetching data from ${endpoint}:`, error);
        return null;
    }
};

export default fetchFromWordpressApi;
